import axios from "axios";
import firebase from "./firebase";
import request from "../infra/request";

export const fetchAppointmentDetailsService = async ({ appointmentId, practitionerId, clientId }) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.get(`${process.env.REACT_APP_DB4_APPOINTMENT}?`, {
    headers: { Authorization: `Bearer ${userIdToken}` },
    params: {
      appointmentId,
      practitionerId,
      clientId,
    },
  });
};

export const fetchAppointmentsService = async ({ fromDate, toDate, pages }) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.get(`${process.env.REACT_APP_DB4_APPOINTMENTS}?fromDate=${fromDate}&toDate=${toDate}&pages=${pages}`, {
    headers: { Authorization: `Bearer ${userIdToken}` },
  });
};

export const sendDB4Service = async ({
  appointmentId,
  patientEmail,
  patientFullName,
  practitionerFullName,
  dateOfService,
  serviceItems,
}) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.post(
    `${process.env.REACT_APP_EMAIL_DB4}`,
    {
      appointmentId,
      patientEmail,
      patientFullName,
      practitionerFullName,
      dateOfService,
      serviceItems,
    },
    { headers: { Authorization: `Bearer ${userIdToken}` } }
  );
};

export const sendAppointmentNotificationService = async ({ appointment }) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.post(
    `${process.env.REACT_APP_EMAIL_APPOINTMENT_TO_DOCTOR}`,
    {
      log: "appointment_to_doctor_notification",
      appointmentId: appointment.id,
      to: `${appointment.practitionerEmail}, ${appointment.referrerEmail}`,
      subject: `Telehealth Dial-in for ${appointment.patientFirstName} ${appointment.patientSurname}`,
      data: appointment,
    },
    { headers: { Authorization: `Bearer ${userIdToken}` } }
  );
};

export const sendPatientNotificationService = async ({ appointment }) => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.post(
    `${process.env.REACT_APP_EMAIL_APPOINTMENT_TO_PATIENT}`,
    {
      log: "appointment_to_patient_notification",
      appointmentId: appointment.id,
      to: `${appointment.patientEmail}`,
      subject: `Telehealth Dial-in for ${appointment.patientFirstName} ${appointment.patientSurname}`,
      data: appointment,
    },
    { headers: { Authorization: `Bearer ${userIdToken}` } }
  );
};

export const getCoreplusPreload = async () => {
  const userIdToken = await firebase.currentUser().getIdToken();
  return axios.get(process.env.REACT_APP_COREPLUS_PRELOAD, {
    headers: { Authorization: `Bearer ${userIdToken}` },
  });
};

export const getSpecialists = async () => {
  const response = await request.get("/admin/specialists");
  return { specialists: response.data.specialists };
};

export const getFirestorePreload = async () => {
  const shouldUsePMSData = process.env.REACT_APP_DATA_SOURCE === "pms-api";
  console.log("process.env.REACT_APP_DATA_SOURCE", process.env.REACT_APP_DATA_SOURCE);
  if (shouldUsePMSData) {
    console.log("Using PMS data");
  } else {
    console.log("Using Core+ data");
  }

  // The backend reads the same fifteen collections; source picks the PMS or the Core+ copies,
  // as this build's REACT_APP_DATA_SOURCE did when the reads were made here.
  const response = await request.get("/admin/preload", {
    params: { source: shouldUsePMSData ? "pms" : "coreplus" },
  });
  return response.data;
};
